<template>
    <div>
        <button class="btn btn-lg btn-primary mb-3" @click="handleNewOptionClick">New Repair / Replacement</button>
        <button type="button" class="btn btn-secondary btn-sm float-right ml-2 mb-2" v-on:click="search()"><i class="fas fa-sync-alt"></i> Refresh</button>
        <data-list-pagination :dataCols="cols"
                              :dataListItems="dataList"
                              :tableClass="'table table-striped table-sm'"
                              :iconFuncs="[optionIconOutstandingTasks]"
                              :actions="actions"
                              @dbl-click="handleDblClick"
                              @action-click="handleActionClick"
                              @pagination-input="handlePaginationInput" />

        <b-modal :id="'options-cancel-modal-' + $vnode.key" title="Cancel Repair / Replace Option" @hidden="resetSelectedItem()" @ok="handleCancelOption()">
            <div v-if="selectedItem" class="d-block text-center">
                <div class="row">
                    <div class="col"><strong>Type:</strong></div>
                    <div class="col">{{selectedItem.typeLabel}}</div>
                </div>
                <div class="row">
                    <div class="col"><strong>Make</strong></div>
                    <div class="col">{{selectedItem.makeLabel}}</div>
                </div>
                <div class="row">
                    <div class="col"><strong>Model</strong></div>
                    <div class="col">{{selectedItem.modelLabel}}</div>
                </div>
                <div class="row">
                    <div class="col"><strong>IMEI / Serial</strong></div>
                    <div class="col">{{selectedItem.imeiNo}} {{selectedItem.serialNo}}</div>
                </div>
                <div class="row">
                    <div class="col"><strong>Option</strong></div>
                    <div class="col">{{selectedItem.repairOptionTypeLabel}}</div>
                </div>
                <div class="row">
                    <div class="col"><strong>Provider</strong></div>
                    <div class="col">{{selectedItem.repairProviderLabel}}</div>
                </div>
            </div>
            <br />
            <b-alert dismissible variant="danger" :show="true">
                <p class="mt-2">Are you sure you want to cancel the above option for the device?</p>
            </b-alert>
            <p>Click OK to cancel the option or Cancel to close this window.</p>
        </b-modal>
        <b-modal :id="'options-note-modal-' + $vnode.key" title="Add Provider Note" @hidden="resetNotes" @ok="handleAddNote">
            <div v-if="selectedItem && selectedItem.noteId">
                <b-alert dismissible variant="danger" :show="true">
                    <p class="mt-2">There is already a note set for this option:</p>
                    <p class="font-weight-bold font-italic"><q>{{selectedItem.noteDetail}}</q></p>
                    <p>You can replace this note by entering the new information in the text box below and clicking OK.  Clicking Cancel will close this window without replacing the note.</p>
                </b-alert>
            </div>
            <div v-else>
                <b-alert dismissible variant="warning" :show="true">
                    <p class="mt-2">You can add a note by entering the new information in the text box below and clicking OK.  Clicking Cancel will close this window without adding the note.</p>
                </b-alert>
            </div>
            <div class="form-group">
                <label :for="'optionNote-' + $vnode.key">Note</label>
                <input type="text" class="form-control form-control-sm" :id="'optionNote-' + $vnode.key" v-model="newNote" placeholder="Note for option">
                <div v-if="showNoteErrMsg" class="invalid-feedback d-block">
                    {{noteErrMsg}}
                </div>
            </div>
        </b-modal>
        <b-modal :id="'options-new-modal-' + $vnode.key" size="xl" title="New Repair / Replacement" @hidden="resetSelectedGadget()" :ok-only="true" :ok-title="'Close'" :ok-variant="'danger'">
            <p>1. Select gadget</p>
            <select class="form-control  form-control-sm"
                    :id="gadgets"
                    v-model="selectedGadget">
                <option :value="null">
                    {{'SELECT...'}}
                </option>
                <option v-for="(g, idx) in gadgets"
                        :key="g.itemGuid + '_' + idx"
                        :value="g"
                        :selected="gadgets.length == 1">
                    {{g.displayLabel}}
                </option>
            </select>
            <div v-if="selectedGadget">
                <p class="mt-2">2. Add option(s) </p>
                <div class="form-check">
                    <input class="form-check-input" type="radio" name="optionStep2" id="exampleRadios1" value="1" v-model="step2Choice">
                    <label class="form-check-label" for="exampleRadios1">
                        Add option(s) for customer to select
                    </label>
                </div>
                <div class="form-check">
                    <input class="form-check-input" type="radio" name="optionStep2" id="exampleRadios2" value="2" v-model="step2Choice">
                    <label class="form-check-label" for="exampleRadios2">
                        Select an option
                    </label>
                </div>

                <div v-if="step2Choice==1" class="mt-2 border  border-light rounded p-2">
                    <div v-if="hasOptionSelected">
                        <p>Not available because an option has been selected for this gadget!</p>
                    </div>
                    <div v-else>
                        <p>Options preview</p>
                        <b-list-group v-if="optionsPreviewForGadget">
                            <b-list-group-item v-for="(option, index) in optionsPreviewForGadget.availableOptions" class="flex-column align-items-start">
                                <div class="d-flex w-100 justify-content-between">
                                    <h5 class="mb-1">{{option.repairOptionWebDisplayTitle}} ({{option.repairProviderLabel}})</h5>
                                    <i class="far fa-trash-alt" style="cursor: pointer;" @click="handleDelOptionClick(option)"></i>
                                </div>
                                <span class="badge badge-primary badge-pill">{{optionMauallySet(option)}}</span>
                                <div v-if="showDecoratorsForOption(option)">
                                    <div v-if="option.ber != null" class="row mt-2">
                                        <div class="col-2">
                                            <span class="font-weight-bold">BER</span>
                                        </div>
                                        <div class="col">
                                            {{formatYesNo(option.ber)}}
                                        </div>
                                    </div>
                                    <div v-if="option.quote != null" class="row">
                                        <div class="col-2">
                                            <span class="font-weight-bold">Quote</span>
</div>
                                        <div class="col">
                                            {{formatYesNo(option.quote)}}
                                        </div>
                                    </div>
                                    <div v-if="option.note != null" class="row">
                                        <div class="col-2">
                                            <span class="font-weight-bold">Note</span>
</div>
                                        <div class="col">
                                            {{option.note}}
                                        </div>
                                    </div>
                                </div>

                                <!--<small class="text-muted">Donec id elit non mi porta.</small>-->
                            </b-list-group-item>
                        </b-list-group>
                        <!--<ul v-if="optionsPreviewForGadget" class="list-group">
                            <li v-for="(option, index) in optionsPreviewForGadget.availableOptions" class="list-group-item d-flex justify-content-between align-items-center">
                                <span>
                                    {{option.repairOptionWebDisplayTitle}} ({{option.repairProviderLabel}}) BER ({{option.ber}}) Quote ({{option.quote}}) Note ({{option.note}})
                                    <span class="badge badge-primary badge-pill">{{optionMauallySet(option)}}</span>
                                </span>
                                <i class="far fa-trash-alt" style="cursor: pointer;" @click="handleDelOptionClick(option)"></i>
                            </li>
                        </ul>-->
                        <div v-else class="d-flex justify-content-center">
                            <div v-if="gettingOptionPreview == true" class="spinner-border" role="status">
                                <span class="sr-only">Loading...</span>
                            </div>
                            <div v-else>
                                <span>No options returned!</span>
                            </div>
                        </div>

                        <p class="mt-2">Add option {{ optionsPreviewForGadget && optionsPreviewForGadget.availableOptions && optionsPreviewForGadget.availableOptions.length > 0 && !optionsPreviewForGadget.availableOptions[0].setManually ? '(Replaces the above)' : ''}}</p>
                        <select class="form-control  form-control-sm"
                                :id="'manOptions'"
                                v-model="selectedOption">
                            <option :value="null">
                                {{'SELECT...'}}
                            </option>
                            <option v-for="(o, idx) in manOptionsList"
                                    :key="o.id + '_' + idx"
                                    :value="o">
                                {{ o.label }}
                            </option>
                        </select>
                        <div v-if="showDecoratorsForOption(selectedOption)">
                            <div class="form-check mt-2">
                                <input class="form-check-input" type="checkbox" v-model="optionBER" id="checkBER">
                                <label class="form-check-label" for="checkBER">
                                    BER
                                </label>
                            </div>

                            <div class="form-check">
                                <input class="form-check-input" type="checkbox" v-model="optionQuote" id="checkQuote">
                                <label class="form-check-label" for="checkQuote">
                                    Quote
                                </label>
                            </div>

                            <div class="form-group mt-2">
                                <label :for="'optionNote-' + $vnode.key">Note (optional)</label>
                                <input type="text" class="form-control form-control-sm" :id="'optionNote-' + $vnode.key" v-model="newNote" placeholder="Note for option">
                                <div v-if="showNoteErrMsg" class="invalid-feedback d-block">
                                    {{noteErrMsg}}
                                </div>
                            </div>
                        </div>
                        <button type="button" class="btn btn-success  mt-2" :disabled="selectedOption == null" @click="handleAddOptionClick">Add option</button>
                        <button type="button" class="btn btn-success mt-2 ml-2" :disabled="selectedOption == null" @click="handleAddOptionAndCloseClick">Add option and Close</button>
                    </div>
                </div>
                <div v-if="step2Choice==2" class="mt-2 border  border-light rounded p-2">
                    <div v-if="selectedClaimApproved">
                        <p class="mt-2">Options</p>
                        <select class="form-control  form-control-sm"
                                :id="'manOptions'"
                                v-model="selectedOption">
                            <option :value="null">
                                {{'SELECT...'}}
                            </option>
                            <option v-for="(o, idx) in manOptionsList"
                                    :key="o.id + '_' + idx"
                                    :value="o">
                                {{ o.label }}
                            </option>
                        </select>

                        <div v-if="showDecoratorsForOption(selectedOption)">
                            <div class="form-check mt-2">
                                <input class="form-check-input" type="checkbox" v-model="optionBER" id="checkBER">
                                <label class="form-check-label" for="checkBER">
                                    BER
                                </label>
                            </div>

                            <div class="form-check">
                                <input class="form-check-input" type="checkbox" v-model="optionQuote" id="checkQuote">
                                <label class="form-check-label" for="checkQuote">
                                    Quote
                                </label>
                            </div>

                            <div class="form-group mt-2">
                                <label :for="'optionNote-' + $vnode.key">Note (optional)</label>
                                <input type="text" class="form-control form-control-sm" :id="'optionNote-' + $vnode.key" v-model="newNote" placeholder="Note for option">
                                <div v-if="showNoteErrMsg" class="invalid-feedback d-block">
                                    {{noteErrMsg}}
                                </div>
                            </div>
                        </div>
                        <div v-if="selectedOption && selectedOption.repairOptionTypeId == 1007">
                            <div class="form-group mt-2">
                                <label :for="'optionAmount-' + $vnode.key">Amount</label>
                                <currency-input :id="'optionAmount-' + $vnode.key" v-model="newAmount" />
                                <div v-if="overCoverLimit" class="invalid-feedback d-block">
                                    Amount is over cover limit, please check!
                                </div>
                            </div>
                            <div class="form-group mt-2">
                                <label :for="'optionNote-' + $vnode.key">Note (optional)</label>
                                <input type="text" class="form-control form-control-sm" :id="'optionNote-' + $vnode.key" v-model="newNote" placeholder="Note for option">
                                <div v-if="showNoteErrMsg" class="invalid-feedback d-block">
                                    {{noteErrMsg}}
                                </div>
                            </div>
                        </div>
                        <button type="button" class="btn btn-success mt-2" :disabled="selectedOption == null" @click="handleSetOptionClick">Set option and Close</button>
                    </div>
                    <div v-else>
                        <p>Not available because claim has not yet been approved!</p>
                    </div>

                </div>
            </div>
        </b-modal>

        <b-modal :id="'options-ber-modal-' + $vnode.key" title="Gadget BER" @ok="handleChangeBER()">
            <div v-if="selectedItem">
                <b-alert dismissible variant="warning" :show="true">
                    <p class="mt-2">You can set this option as BER by checking the box below and clicking OK.  Clicking Cancel will close this window without setting the BER status of the option.</p>
                </b-alert>
                <div class="form-check mt-2 mb-2">
                    <input class="form-check-input" type="checkbox" v-model="selectedItemSetBER" id="checkBER">
                    <label class="form-check-label" for="checkBER">
                        BER
                    </label>
                </div>
            </div>
        </b-modal>

        <b-modal :id="'options-quote-modal-' + $vnode.key" title="Gadget Quote only" @ok="handleChangeQuote()">
            <div v-if="selectedItem">
                <b-alert dismissible variant="warning" :show="true">
                    <p class="mt-2">You can set this option as Quote only by checking the box below and clicking OK.  Clicking Cancel will close this window without setting the Quote only status of the option.</p>
                </b-alert>
                <div class="form-check mt-2 mb-2">
                    <input class="form-check-input" type="checkbox" v-model="selectedItemSetQuote" id="checkQuote">
                    <label class="form-check-label" for="checkQuote">
                        Quote only
                    </label>
                </div>
            </div>
        </b-modal>

        <b-modal :id="'options-faulty-modal-' + $vnode.key" title="Gadget Repair / Replacement Faulty" @ok="handleChangeFaulty()">
            <div v-if="selectedItem">
                <b-alert dismissible variant="warning" :show="true">
                    <p class="mt-2">You can set this option as Faulty by checking the box below and clicking OK.  A return option will be automatically created for you.  Clicking Cancel will close this window without setting the Faulty status of the option.</p>
                </b-alert>
                <div class="form-check mt-2 mb-2">
                    <input class="form-check-input" type="checkbox" v-model="selectedItemSetFaulty" id="checkFaulty">
                    <label class="form-check-label" for="checkFaulty">
                        Faulty
                    </label>
                </div>
            </div>
        </b-modal>

        <b-modal :id="'options-tasks-modal-' + $vnode.key" title="Outstanding Tasks" @ok="handleSetTasks()">
            <div v-if="selectedItem">
                <b-alert dismissible variant="warning" :show="true">
                    <p class="mt-2">Once you have completed the relevant task(s) you can set them as complete by checking the box(es) below and clicking OK.  Clicking Cancel will close this window without setting the task(s) completed.</p>
                </b-alert>
            <settlement-option-outstanding-tasks v-if="selectedItem"  :optionId="selectedItem.id" />
            </div>
        </b-modal>

        <b-modal :id="'options-details-modal-' + $vnode.key" title="More Details" size="lg" ok-only ok-variant="secondary" ok-title="Cancel">
            <div v-if="selectedItem">
                <settlement-option-history :optionId="selectedItem.id" />

                <div class="row mt-2">
                    <div class="col pl-4 p-2">
                        <span>Gadget</span>
                    </div>
                    <div class="col-7 border-left pl-4 p-2">
                        <span>{{selectedItem.displayLabel}}</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col pl-4 p-2">
                        <span>Option</span>
                    </div>
                    <div class="col-7 border-left pl-4 p-2">
                        <span>{{selectedItem.repairOptionTypeLabel}} / {{selectedItem.repairProviderLabel}}</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col pl-4 p-2">
                        <span>Auth ID</span>
                    </div>
                    <div class="col-7 border-left pl-4 p-2">
                        <span>{{selectedItem.authorisationId != null ? selectedItem.authorisationId : 'NOT AVAILABLE' }}</span>  &nbsp;
                        <copy-to-clipboard :textToCopy="selectedItem.authorisationId" />
                    </div>
                </div>
                <div class="row">
                    <div class="col pl-4 p-2">
                        <span>Selected</span>
                    </div>
                    <div class="col-7 border-left pl-4 p-2">
                        <span>{{FormatDate(selectedItem.dateCreated)}}</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col pl-4 p-2">
                        <span>Cancelled</span>
                    </div>
                    <div class="col-7 border-left pl-4 p-2">
                        <span>{{FormatDate(selectedItem.dateCancelled)}}</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col pl-4 p-2">
                        <span>Notes / instructions</span>
                    </div>
                    <div class="col-7 border-left pl-4 p-2">
                        <div v-if="selectedItem.noteDetail" class="alert alert-info" role="alert">
                            <span class="font-weight-bold">&quot;{{selectedItem.noteDetail}}&quot;</span>&nbsp;
                            <!--<copy-to-clipboard :textToCopy="selectedItem.noteDetail" />-->
                            <div class="row mt-2">
                                <div class="col">
                                    <span class="text-muted text-small">Created: {{FormatDate(selectedItem.dateNoteCreated)}}</span>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <span class="text-muted text-small">By: {{selectedItem.noteCreatedBy}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col pl-4 p-2">
                        <span>Dispatch Tracking ID</span>
                    </div>
                    <div class="col-7 border-left pl-4 p-2">
                        <span>{{selectedItem.dispatchTrackingId != null ? selectedItem.dispatchTrackingId : 'NOT AVAILABLE' }}</span>  &nbsp;
                        <copy-to-clipboard :textToCopy="selectedItem.dispatchTrackingId" />
                    </div>
                </div>
                <div class="row">
                    <div class="col pl-4 p-2">
                        <span>IMEI</span>
                    </div>
                    <div class="col-7 border-left pl-4 p-2">
                        <span>{{selectedItem.imeiNo != null ? selectedItem.imeiNo : 'NOT AVAILABLE' }}</span>  &nbsp;
                        <copy-to-clipboard :textToCopy="selectedItem.imeiNo" />
                    </div>
                </div>
                <div class="row">
                    <div class="col pl-4 p-2">
                        <span>IMEI2</span>
                    </div>
                    <div class="col-7 border-left pl-4 p-2">
                        <span>{{selectedItem.imeiNo2 != null ? selectedItem.imeiNo2 : 'NOT AVAILABLE' }}</span>  &nbsp;
                        <copy-to-clipboard :textToCopy="selectedItem.imeiNo2" />
                    </div>
                </div>
                <div class="row">
                    <div class="col pl-4 p-2">
                        <span>Replacement IMEI</span>
                    </div>
                    <div class="col-7 border-left pl-4 p-2">
                        <span>{{selectedItem.replacementIMEINo != null ? selectedItem.replacementIMEINo : 'NOT AVAILABLE' }}</span>  &nbsp;
                        <copy-to-clipboard :textToCopy="selectedItem.replacementIMEINo" />
                    </div>
                </div>
                <div class="row">
                    <div class="col pl-4 p-2">
                        <span>Serial</span>
                    </div>
                    <div class="col-7 border-left pl-4 p-2">
                        <span>{{selectedItem.serialNo != null ? selectedItem.serialNo : 'NOT AVAILABLE' }}</span>  &nbsp;
                        <copy-to-clipboard :textToCopy="selectedItem.serialNo" />
                    </div>
                </div>
                <div class="row">
                    <div class="col pl-4 p-2">
                        <span>Replacement Serial</span>
                    </div>
                    <div class="col-7 border-left pl-4 p-2">
                        <span>{{selectedItem.replacementSerialNo != null ? selectedItem.replacementSerialNo : 'NOT AVAILABLE' }}</span>  &nbsp;
                        <copy-to-clipboard :textToCopy="selectedItem.replacementSerialNo" />
                    </div>
                </div>
                <div class="row">
                    <div class="col pl-4 p-2">
                        <span>Archived</span>
                    </div>
                    <div class="col-7 border-left pl-4 p-2">
                        <span>{{formatYesNo(selectedItem.archived)}}</span>
                        <div v-if="selectedItem.archivedDate" class="w-100">
                            <small class="text-muted">On: {{FormatDate(selectedItem.archivedDate)}}</small>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col pl-4 p-2">
                        <span>BER</span>
                    </div>
                    <div class="col-7 border-left pl-4 p-2">
                        <span>{{formatYesNo(selectedItem.ber)}}</span>
                        <div v-if="selectedItem.ber" class="w-100">
                            <small class="text-muted">Last updated: {{FormatDate(selectedItem.berLastUpdatedDate)}}</small>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col pl-4 p-2">
                        <span>Quote</span>
                    </div>
                    <div class="col-7 border-left pl-4 p-2">
                        <span>{{formatYesNo(selectedItem.quote)}}</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col pl-4 p-2">
                        <span>Quote amount</span>
                    </div>
                    <div class="col-7 border-left pl-4 p-2">
                        <span>{{selectedItem.quotedCost}}</span>
                        <div v-if="selectedItem.quotedCostLastUpdatedDate" class="w-100">
                            <small class="text-muted">Last updated: {{FormatDate(selectedItem.quotedCostLastUpdatedDate)}}</small>
                        </div>
                        <div v-if="selectedItem.quoteCurrencyCode" class="w-100">
                            <small class="text-muted">Currency: {{selectedItem.quoteCurrencyCode}}</small>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col pl-4 p-2">
                        <span>Supplier Quote Date</span>
                    </div>
                    <div class="col-7 border-left pl-4 p-2">
                        <span>{{FormatDate(selectedItem.supplierQuoteDate)}}</span>&nbsp;
                        <copy-to-clipboard :textToCopy="selectedItem.supplierQuoteDate" />
                    </div>
                </div>
                <div class="row">
                    <div class="col pl-4 p-2">
                        <span>Quote Auth ID</span>
                    </div>
                    <div class="col-7 border-left pl-4 p-2">
                        <span>{{selectedItem.quoteAuthId != null ? selectedItem.quoteAuthId : 'NOT AVAILABLE' }}</span>  &nbsp;
                        <copy-to-clipboard :textToCopy="selectedItem.quoteAuthId" />
                    </div>
                </div>
                <div class="row">
                    <div class="col pl-4 p-2">
                        <span>User account active</span>
                    </div>
                    <div class="col-7 border-left pl-4 p-2">
                        <span>{{formatYesNo(selectedItem.userAccountActive)}}</span>
                        <div v-if="selectedItem.userAccountActiveLastUpdated" class="w-100">
                            <small class="text-muted">Last updated: {{FormatDate(selectedItem.userAccountActiveLastUpdated)}}</small>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col pl-4 p-2">
                        <span>Last used on</span>
                    </div>
                    <div class="col-7 border-left pl-4 p-2">
                        <span>{{FormatDate(selectedItem.lastUsageDate)}}</span>&nbsp;
                        <copy-to-clipboard :textToCopy="selectedItem.lastUsageDate" />
                    </div>
                </div>
                <div class="row">
                    <div class="col pl-4 p-2">
                        <span>Previous repairs</span>
                    </div>
                    <div class="col-7 border-left pl-4 p-2">
                        <span>{{formatYesNo(selectedItem.previousRepairs)}}</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col pl-4 p-2">
                        <span>Inspection notes</span>
                    </div>
                    <div class="col-7 border-left pl-4 p-2">
                        <span>{{selectedItem.inspectionNotes}}</span>&nbsp;
                        <copy-to-clipboard :textToCopy="selectedItem.inspectionNotes" />
                    </div>
                </div>
                <div class="row">
                    <div class="col pl-4 p-2">
                        <span>Notes</span>
                    </div>
                    <div class="col-7 border-left pl-4 p-2">
                        <span>{{selectedItem.supplierNotes}}</span>&nbsp;
                        <copy-to-clipboard :textToCopy="selectedItem.supplierNotes" />
                    </div>
                </div>
                <div class="row">
                    <div class="col pl-4 p-2">
                        <span>Received date</span>
                    </div>
                    <div class="col-7 border-left pl-4 p-2">
                        <span>{{FormatDate(selectedItem.receivedDate)}}</span>&nbsp;
                        <copy-to-clipboard :textToCopy="selectedItem.receivedDate" />
                    </div>
                </div>
                <div class="row">
                    <div class="col pl-4 p-2">
                        <span>Dispatched date</span>
                    </div>
                    <div class="col-7 border-left pl-4 p-2">
                        <span>{{FormatDate(selectedItem.dispatchedDate)}}</span>&nbsp;
                        <copy-to-clipboard :textToCopy="selectedItem.dispatchedDate" />
                        <div v-if="selectedItem.dispatchTrackingId" class="w-100">
                            <small class="text-muted">Tracking ID: {{selectedItem.dispatchTrackingId}}</small>
                        </div>
                        <div v-if="selectedItem.dispatchCourierLabel" class="w-100">
                            <small class="text-muted">Courier: {{selectedItem.dispatchCourierLabel}}</small>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col pl-4 p-2">
                        <span>Faulty repair</span>
                    </div>
                    <div class="col-7 border-left pl-4 p-2">
                        <span>{{formatYesNo(selectedItem.faulty)}}</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col pl-4 p-2">
                        <span>Warranty</span>
                    </div>
                    <div class="col-7 border-left pl-4 p-2">
                        <span>{{formatYesNo(selectedItem.warranty)}}</span>
                    </div>
                </div>

            </div>
        </b-modal>

    </div>
</template>

<script>
    import DataListPagination from '@/components/DataListPagination.vue'
    import SettlementOptionHistory from '@/components/SettlementOptionHistory.vue'
    import SettlementOptionOutstandingTasks from '@/components/SettlementOptionOutstandingTasks.vue'

    import CopyToClipboard from '@/components/CopyToClipboard.vue'

    import currencyInput from '@/components/currency-input.vue'

    import { repairsCols } from '@/ui.config/cols/repairsCols'
    import { mapActions, mapGetters } from 'vuex'

    import { repairOptionApiService } from '@/services/repairOption-api.service'

    import moment from "moment";

    import { formatNumber } from '@/util/formatters'

    export default {
        name: 'ClaimRepairOptionList',
        props: {
            reload: Boolean
        },
        components: {
            DataListPagination,
            'settlement-option-history': SettlementOptionHistory,
            'settlement-option-outstanding-tasks': SettlementOptionOutstandingTasks,
            'copy-to-clipboard': CopyToClipboard,
            'currency-input': currencyInput
        },
        data: () => {
            return {
                cols: repairsCols,

                pageNumber: 1,
                pageSize: 10,

                selectedItem: null,

                newNote: null,
                showNoteErrMsg: false,
                noteErrMsg: 'A note is required and it must be no longer than 250 characters including spaces!',
                noteList: null,

                selectedGadget: null,
                step2Choice: null,
                selectedOption: null,
                optionBER: null,
                optionQuote: null,

                selectedItemSetBER: null,
                selectedItemSetQuote: null,
                selectedItemSetFaulty: null,

                gettingOptionPreview: false,

                outstandingTasks: [],

                copyToPopupText: 'Copy to clipboard',

                windowWidth: 0,

                newAmount: 0
            }
        },
        watch: {
            reload(newVal) {
                console.log('ClaimRepairOptionList - reload')
                if (newVal == true && (this.dataList.length == 0)) {
                    this.search()
                }
            },
            selectedClaim(newVal) {
                if (this.reload == true && (this.dataList.length == 0)) {
                    this.search()
                }
            },
            selectedGadget(newVal) {
                if (this.selectedGadget) {
                    let self = this
                    self.gettingOptionPreview = true
                    this.getOptionPreview(this.selectedGadget.webReference)
                        .then(response => {

                        }).finally(() => { self.gettingOptionPreview = false })
                    this.getManOptions(this.manRROptionsParams)
                }
            }
        },
        computed: {
            ...mapGetters([
                'selectedClaim',
                'selectedRROptionsForSelectedClaim',
                'gadgetsDisplayLabelForSelectedClaim',
                'manDeviceRepairPreConfigItems',
                'gadgetOptionsPreview',
                'selectedRROptionHistoryForGadget',
                'currentSelectedRROptionForGadget',
                'selectedClaimGadgetByWebRef',
                'selectedClaimApproved'
            ]),
            policyDetails() {
                return this.selectedClaim.policyDetails
            },
            coverLimit() {
                if (this.policyDetails.policyRatingTypeId == 1) {
                    const gadget = this.selectedClaim.gadgetDetails.find(g => g.id == this.selectedGadget.id)
                    
                    return formatNumber(2)(gadget.value)
                }
                if (this.policyDetails.policyRatingTypeId == 2) {
                    if (this.policyDetails.sal) {
                        return formatNumber(2)(this.policyDetails.sal)
                    } else {
                        return formatNumber(2)(this.policyDetails.coverLimit)
                    }
                }
            },
            overCoverLimit() {
                try {
                    return this.newAmount > this.coverLimit
                } catch {
                    return false
                }
            },
            dataList() {
                return this.selectedRROptionsForSelectedClaim
            },
            gadgets() {
                return this.gadgetsDisplayLabelForSelectedClaim
            },
            manOptionsList() {
                return this.manDeviceRepairPreConfigItems
            },
            optionsPreviewForGadget() {
                return this.gadgetOptionsPreview
            },
            actions() {
                return [
                    {
                        id: 1,
                        name: 'notes',
                        text: 'Update Note',
                        buttonClass: 'btn btn-primary btn-sm',
                        iconClass: 'far fa-sticky-note'
                    },
                    {
                        id: 3,
                        name: 'ber',
                        text: 'Set BER',
                        buttonClass: 'btn btn-warning btn-sm',
                        iconClass: 'fas fa-exclamation-triangle'
                    },
                    {
                        id: 4,
                        name: 'quote',
                        text: 'Set Quote only',
                        buttonClass: 'btn btn-warning btn-sm',
                        iconClass: 'fas fa-question'
                    },
                    {
                        id: 2,
                        name: 'cancel',
                        text: 'Cancel',
                        buttonClass: 'btn btn-danger btn-sm',
                        iconClass: 'fas fa-ban',
                        disabled: (item) => item.dateCancelledAsLocalTime != null
                    },
                    {
                        id: 5,
                        name: 'faulty',
                        text: 'Set Faulty',
                        buttonClass: 'btn btn-warning btn-sm',
                        iconClass: 'fas fa-tools'
                    },
                    {
                        id: 6,
                        name: 'tasks',
                        text: 'Outstanding Tasks',
                        buttonClass: 'btn btn-warning btn-sm',
                        iconClass: 'fas fa-tasks'
                    }
                ]
            },
            manRROptionsParams() {
                let { resellerId, incidentDetails } = this.selectedClaim

                let { incidentTypeId } = incidentDetails

                let gadget = this.selectedClaimGadgetByWebRef(this.selectedGadget.webReference)

                let { typeId, makeId } = gadget

                let optionBER = null

                if (this.selectedRepairOptionForGadget) {
                    let { ber } = this.selectedRepairOptionForGadget
                    optionBER = ber
                }

                return {
                    resellerId,
                    incidentTypeId,
                    deviceTypeId: typeId,
                    deviceMakeId: makeId,
                    prevOptionBER: optionBER
                }
            },
            selectedRepairOptionForGadget() {
                return this.currentSelectedRROptionForGadget(this.selectedGadget.id)
            },
            hasOptionSelected() {
                let { selectedRepairOptionForGadget } = this
                if (selectedRepairOptionForGadget) {
                    if (selectedRepairOptionForGadget.dateCancelled) {
                        return false
                    } else {
                        return true
                    }
                }
                return false
            }
        },
        methods: {
            ...mapActions({
                fetchData: 'fetchSelectedRepairOptionsClaim',
                cancelOption: 'cancelSelectedOption',
                addNote: 'addSelectedOptionNote',
                getManOptions: 'fetchManDeviceRepairPreConfigItems',
                setManOption: 'addManualOptionForGadgetFromPreConfig',
                addManOptionFromSys: 'addManualOptionForGadgetFromSys',
                delManOption: 'delManualOption',
                getOptionPreview: 'fetchOptionsPreviewForGadget',
                resetOptionPreview: 'resetOptionsPreviewForGadget',
                setSelectedRROption: 'setSelectedRROptionForGadget',
                setBER: 'setSelectedRROptionBER',
                setQuoteOnly: 'setSelectedRROptionQuoteOnly',
                setFaulty: 'setSelectedRROptionFaulty'
            }),
            isAmountOverCoverlimit(val, coverlimit) {
                console.log(val)
                console.log(coverlimit)
                return val > coverlimit
            },
            handleNoteChange() {
                this.newNoteDirty = true
            },
            handlePaginationInput(payload) {
                if (payload) {
                    this.pageNumber = payload
                    this.search()
                }
            },
            resetSelectedItem() {
                this.selectedItem = null
            },
            resetSelectedGadget() {
                this.selectedGadget = null
                this.step2Choice = null
                this.resetSelectedItem()
            },
            handleActionClick(payload) {
                if (payload && payload.action && payload.item) {
                    this.selectedItem = payload.item
                    switch (payload.action.id) {
                        case 1:
                            // Notes
                            this.$bvModal.show('options-note-modal-' + this.$vnode.key)
                            break;
                        case 2:
                            // Cancel
                            this.$bvModal.show('options-cancel-modal-' + this.$vnode.key)
                            break;
                        case 3:
                            // BER
                            this.selectedItemSetBER = this.selectedItem.ber
                            this.$bvModal.show('options-ber-modal-' + this.$vnode.key)
                            break;
                        case 4:
                            // Quote
                            this.selectedItemSetQuote = this.selectedItem.quote
                            this.$bvModal.show('options-quote-modal-' + this.$vnode.key)
                            break;
                        case 5:
                            // Faulty
                            this.selectedItemSetFaulty = this.selectedItem.faulty
                            this.$bvModal.show('options-faulty-modal-' + this.$vnode.key)
                            break;
                        case 6:
                            // Outstanding Tasks
                            this.$bvModal.show('options-tasks-modal-' + this.$vnode.key)
                            //repairOptionApiService.getSettlementOptionOutstandingTasks(this.selectedItem.id)
                            //    .then((response) => {
                            //        let { data, pagination, messages } = response.data
                            //        this.outstandingTasks = data
                            //        resolve(response.data)
                            //    })
                            //    .catch((error) => {
                            //        if (reject) {
                            //            reject(error)
                            //        }
                            //    })
                            //    .finally(() => { /*commit('setLoading', false)*/ })
                        default:
                        // ?
                    }

                }

            },
            handleCancelOption() {
                let { id, selectedOptionRowVersion } = this.selectedItem
                this.cancelOption({ id, rowVersion: selectedOptionRowVersion })
                    .then(response => {
                        this.search()
                    })
            },
            async handleChangeBER() {

                let { id, selectedOptionRowVersion, ber } = this.selectedItem
                let { selectedItemSetBER } = this
                if (ber != selectedItemSetBER) {
                    try {
                        let result = await this.setBER({ selectedRROptionId: id, newBERValue: selectedItemSetBER, rowVersion: selectedOptionRowVersion })

                    }
                    catch (err) {
                        console.log(err)
                    }
                    this.search()
                }

            },
            async handleChangeFaulty() {
                let { id, selectedOptionRowVersion, faulty } = this.selectedItem
                let { selectedItemSetFaulty } = this
                if (faulty != selectedItemSetFaulty) {
                    try {
                        let result = await this.setFaulty({ selectedRROptionId: id, newFaultyValue: selectedItemSetFaulty, rowVersion: selectedOptionRowVersion })

                    }
                    catch (err) {
                        console.log(err)
                    }
                    this.search()
                }
            },
            async handleChangeQuote() {

                let { id, selectedOptionRowVersion, quote } = this.selectedItem
                let { selectedItemSetQuote } = this
                if (quote != selectedItemSetQuote) {
                    try {
                        let result = await this.setQuoteOnly({ selectedRROptionId: id, newQuoteOnlyValue: selectedItemSetQuote, rowVersion: selectedOptionRowVersion })

                    }
                    catch (err) {
                        console.log(err)
                    }
                    this.search()
                }

            },
            optionMauallySet(option) {
                if (option) {
                    if (option.setManually) {
                        return 'Manual'
                    } else {
                        return 'System'
                    }
                }
            },
            handleAddNote(bvModalEvt) {
                bvModalEvt.preventDefault()

                if (this.newNote && this.newNote.length <= 250) {
                    this.$nextTick(() => {
                        this.$bvModal.hide('options-note-modal-' + this.$vnode.key)
                    })
                    let { id, noteId } = this.selectedItem
                    this.addNote({ selectedRepairOptionId: id, prevNoteId: noteId, detail: this.newNote })
                        .then(response => {
                            this.search()
                        })

                    this.resetNotes()
                } else {
                    this.showNoteErrMsg = true
                }
            },
            handleNewOptionClick() {

                if (this.gadgets && this.gadgets.length == 1) {
                    this.selectedGadget = this.gadgets[0]
                }
                this.$bvModal.show('options-new-modal-' + this.$vnode.key)
            },
            async handleAddOptionClick() {
                let { id: preConfigId } = this.selectedOption
                let { id: gadgetId, webReference: gadgetWebReference } = this.selectedGadget
                let { optionBER: ber, optionQuote: quote, newNote: note, newAmount: amount } = this

                this.setManOption({ gadgetWebReference, gadgetId, preConfigId, ber, quote, note, amount })

                this.selectedOption = null
                this.optionBER = null
                this.optionQuote = null
                this.newNote = null
                this.search()
            },
            async handleAddOptionAndCloseClick() {
                await this.handleAddOptionClick()
                this.$bvModal.hide('options-new-modal-' + this.$vnode.key)

                this.search()
            },
            async handleSetOptionClick() {
                let { repairProviderId: providerId, repairOptionTypeId: optionTypeId } = this.selectedOption
                let { id: gadgetId } = this.selectedGadget
                let { optionBER: ber, optionQuote: quote, newNote: note, newAmount: amount } = this

                let apiResponse = await this.setSelectedRROption({ optionTypeId, providerId, gadgetId, ber, quote, note, amount })
                    .catch(err => console.log('await - catch : ', err))
                this.selectedOption = null
                this.optionBER = null
                this.optionQuote = null
                this.newNote = null

                this.$bvModal.hide('options-new-modal-' + this.$vnode.key)

                this.search()
            },
            handleDelOptionClick(option) {

                let { id: gadgetId, webReference: gadgetWebReference } = this.selectedGadget

                let { id, setManually } = option
                if (setManually == false) {
                    let copyOpts = this.optionsPreviewForGadget.availableOptions.filter(o => o.id != id)
                    let payload = { gadgetWebReference, gadgetId, optionIds: copyOpts.map(o => { return o.id }) }

                    this.addManOptionFromSys(payload)
                } else {

                    this.delManOption({ optionId: option.id, gadgetWebReference })
                }
            },
            resetNotes() {
                this.newNote = null
                this.noteList = null
                this.showNoteErrMsg = false
            },
            search() {
                let { claimId } = this.selectedClaim
                let { pageSize, pageNumber } = this

                let ordering = null

                let pages = {
                    pageSize,
                    pageNumber
                }

                let criteria = {
                    claimId,
                    ...pages,
                    ...ordering
                }

                this.fetchData(criteria)
            },
            handleResize() {
                this.windowWidth = window.innerWidth;
            },
            showDecoratorsForOption(option) {
                if (option) {
                    if (option.repairOptionTypeId == 1007 || option.repairOptionTypeId == 1008 || option.repairOptionTypeId == 1000) {
                        return false
                    } else {
                        return true
                    }
                } else {
                    return false
                }
            },
            optionIconOutstandingTasks(item) {
                if (item && item.outstandingTaskList && item.outstandingTaskList.length > 0) {
                    return 'fas fa-tasks'
                } else {
                    return 'fas fa-minus'
                }
            },
            handleSetTasks() {
                console.log('handleSetTasks')
            },
            handleDblClick(payload) {
                console.log(payload)
                this.selectedItem = payload
                this.$bvModal.show('options-details-modal-' + this.$vnode.key)
            },
            copyToClipboard(val) {

                var tempInput = document.createElement("input");
                tempInput.value = val;
                document.body.appendChild(tempInput);
                tempInput.select();
                try {
                    if (document.execCommand('copy')) {
                        this.copyToPopupText = 'Copied'
                        let self = this
                        setTimeout(function () {
                            self.copyToPopupText = 'Copy to clipboard'
                        }, 2000);
                    }

                } catch (err) {
                    console.log(err)
                }

                document.body.removeChild(tempInput);


            },
            FormatDate(dte) {
                if (dte) return moment(dte).format("DD/MM/YYYY hh:mm A");

                return "NOT AVAILABLE";
            },
            formatYesNo(val) {
                if (val === undefined || val === null || val.length == 0)
                    return 'NOT AVAILABLE'
                else {
                    var x = Boolean(val);
                    if (x)
                        return 'YES'
                    else
                        return'NO'
                }
            }
        },
        created() {
            window.addEventListener("resize", this.handleResize);
            this.handleResize();
        },
        //mounted() {
        //    console.log('ClaimRepairOptionList - mounted')
        //    if (this.reload == true && (this.dataList.length == 0)) {
        //        this.search()
        //    }
        //}
    }
</script>

